const setItems = (state, action) => {
  const { items } = action.payload;
  return {
    ...state,
    items: items.reduce((acc, item) => {
      acc[item.actionedDate] = item;
      return acc;
    }, {}),
  };
};

const updateItemsCache = (state, action) => {
  const { items } = action.payload;

  const updatedItemsCache = { ...state.itemsCache };

  Object.keys(items).forEach((key) => {
    updatedItemsCache[key] = {
      ...updatedItemsCache[key],
      ...items[key],
    };
  });

  return {
    ...state,
    itemsCache: updatedItemsCache,
  };
};

const setPagination = (state, action) => {
  const { pagination } = action.payload;

  return {
    ...state,
    pagination: {
      size: pagination.size || state.pagination.size,
      skip: pagination.skip || state.pagination.skip,
      totalItemCount:
        pagination.totalItemCount || state.pagination.totalItemCount,
    },
  };
};

const updateSelectedItems = (state, action) => {
  const { selectedItems } = action.payload;

  return {
    ...state,
    selectedItems: {
      ...state.selectedItems,
      ...selectedItems,
    },
  };
};

export const mainReducers = {
  SET_ITEMS: setItems,
  UPDATE_ITEMS_CACHE: updateItemsCache,
  SET_PAGINATION: setPagination,
  UPDATE_SELECTED_ITEMS: updateSelectedItems,
};

export default mainReducers;
